exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button {\n  height: 34px;\n  padding: 7px 15px;\n}\n.button.orange {\n  background-color: #e78221;\n}\n.button.orange:hover {\n  background-color: #e07a18;\n}\n.button.grey {\n  background-color: #AFAFAF;\n}\n.button.grey:hover {\n  background-color: #a7a7a7;\n}\n.button.white {\n  color: #333333;\n  background-color: #fafaff;\n  border: 1px #5F5F5F solid;\n}\n.button.white:hover {\n  background-color: #ebebff;\n}\n.button.float--right {\n  float: right;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/button/button.component.scss
// module id = ../../../../../src/app/components/button/button.component.scss
// module chunks = main